import { Box, IconButton, Stack, Typography } from '@mui/material';

import CloseXIcon from 'modules/common/components/Icons/CloseXIcon';
import { useIMCContext } from 'modules/IMC/common/context';

export default function InboxDrawerContent() {
    // ---- Hooks ----
    const { openDrawer } = useIMCContext();

    // ---- Handlers ----
    const handleClose = () => {
        openDrawer(null);
    };

    // ---- Render ----
    return (
        <Box sx={{ height: '100%', backgroundColor: 'background.paper' }}>
            <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', p: 2 }}>
                <Typography variant="h3">Inbox</Typography>
                <IconButton aria-label="Close inbox" onClick={handleClose} size="small">
                    <CloseXIcon />
                </IconButton>
            </Stack>
        </Box>
    );
}
